import { v4 as uuidv4 } from 'uuid';
import { enc } from 'crypto-js';

const GenerateNew: () => string = () => enc.Base64.parse(uuidv4()).toString();

const GetNonceValue = (): string => {
    const nonceElement = document.getElementById("nonce") || document.querySelector("meta[name='csp-nonce']"),
        result = (nonceElement?.textContent && JSON.parse(nonceElement.textContent)) || GenerateNew();

    return result;
}

export const NonceUUID: string = GetNonceValue();